module.exports = __webpack_public_path__ + "media/images/login/btn_entry_ov-a499aa2b1306052457962a83a142537c.png";